import "./TicketVerification.scss";
import { useCallback, useEffect, useRef, useState } from "react";
import { EventOrganizer, Ticket } from "../../../types/types";
import { useNavigate, useParams } from "react-router-dom";
import { CheckForm } from "../components/CheckForm/CheckForm";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { EventImages } from "../components/EventImages/EventImages";
import { EventTitle } from "../components/EventTitle/EventTitle";
import { EventDatePlace } from "../components/EventDatePlace/EventDatePlace";
import { CheckLink } from "../components/CheckLink/CheckLink";
import { useWidth } from "../../../hooks/useWidth";
import {
  checkAuth,
  formatDate,
  getAuthToken,
  getMinPrice,
} from "../../../utils/utils";
import Loader from "../../../components/Loader/Loader";
import arrow from "../image/arrow.svg";
import chevron from "../image/chevron.svg";
import repost from "../image/repost.svg";
import styles from "./TicketVerification.module.scss";
import { API_BASE } from "../../../config/api";

export const TicketVerification = () => {
  const [event, setEvent] = useState<EventOrganizer>();
  const [eventData, setEventData] = useState<Ticket[]>([]);
  const [foundTickets, setFoundTickets] = useState<Ticket[]>([]);
  const [error, setError] = useState<string | null>(null);
  const nameRef = useRef<HTMLHeadingElement>(null);
  const dateRef = useRef<HTMLHeadingElement>(null);
  const placeRef = useRef<HTMLHeadingElement>(null);
  const addressRef = useRef<HTMLHeadingElement>(null);
  // const [totalWidth, setTotalWidth] = useState<number>(0);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const width = useWidth();
  const url = `${API_BASE}`;
  const { id } = useParams();

  useEffect(() => {
    if (!checkAuth()) {
      navigate("/registrationPage");
    }
  }, [navigate]);

  const token = getAuthToken();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);

        const data = await fetch(`${url}/events/${id}/`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            authorization: `Bearer ${token}`,
          },
        }).then((res) => res.json());

        console.log(data);
        if (
          !data ||
          data.length === 0 ||
          data.detail === "Событие не найдено."
        ) {
          throw new Error("Событие не найдено");
        }

        setEvent(data);
      } catch (error: any) {
        console.error("Ошибка загрузки данных:", error);
        setError(error.message || "Ошибка при загрузке данных");
      }
    };

    fetchData();
  }, [id, token, url]);

  useEffect(() => {
    if (!event) return;
    if (!event.is_owner || event.is_finished || event.is_canceled) {
      navigate("/404");
    }
  }, [event, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        const res = await fetch(`${url}/tickets/${id}/`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) {
          throw new Error("Ошибка загрузки данных");
        }
        const data: Ticket[] = await res.json();
        setEventData(data);
        setFoundTickets(data);
      } catch (error: any) {
        console.error("Ошибка загрузки данных:", error);
        setError(error.message || "Ошибка при загрузке данных");
      }
    };

    fetchData();
  }, [id, token, url]);

  useEffect(() => {
    if (error === "Событие не найдено") {
      navigate("/404");
    }
  }, [error, navigate]);

  const handleScanner = () => {
    navigate(`/organizer_event/${id}/scanner`);
  };

  const getElementsWidth = useCallback(() => {
    if (
      nameRef.current &&
      dateRef.current &&
      placeRef.current &&
      addressRef.current
    ) {
      // setTotalWidth(
      //   nameRef.current.offsetWidth +
      //   dateRef.current.offsetWidth +
      //   placeRef.current.offsetWidth +
      //   addressRef.current.offsetWidth
      // );
    }
  }, []);

  useEffect(() => {
    getElementsWidth();
  }, [width, event, getElementsWidth]);

  if (error === "Событие не найдено") {
    navigate("/404");
  }

  if (!event || !eventData) return <Loader />;

  return isMobile ? (
    <div className="ticket-verification">
      {" "}
      {/*Мобильная версия сайта (1 итерация)*/}
      <section className="ticket-verification__event-info">
        <EventImages
          mainImage={event.cover_medium}
          images={event.photos_data}
        />
        <EventTitle
          id={id}
          title={event.name}
          tickets={event.ticket_types_data}
          btnType="back"
        />
        <button className="btnOutline" onClick={handleScanner}>
          <span>Сканер QR-кода</span>
          <img src={arrow} alt="arrow" />
        </button>
        <EventDatePlace
          starts_at={event.starts_at}
          ends_at={event.ends_at || ""}
          place={event.place || {}}
        />
      </section>
      <section className="ticket-verification__check-form">
        <CheckLink id={id} />
        <CheckForm
          id={event.id}
          eventData={eventData}
          foundTickets={foundTickets}
          setFoundTickets={setFoundTickets}
          type_form={"check"}
        />
      </section>
    </div>
  ) : (
    <div className={styles.ticketVerification}>
      {" "}
      {/*Десктопная версия сайта (2 итерация)*/}
      <section className={styles.card}>
        <div
          className={styles.clickArea}
          onClick={() => navigate(`/event/${id}`)}
        >
          <img
            className={styles.image}
            src={event.cover_medium}
            alt="event_image"
          />
          <div className={styles.info}>
            <h1 className={styles.title}>{event.name}</h1>
            <div className={styles.date}>
              <span className={styles.circle}></span>
              <p>{formatDate(event.starts_at)}</p>
            </div>
            <p
              className={styles.text}
            >{`${event.place.city}, ${event.place.name}`}</p>
          </div>
        </div>
        <div className={styles.buttons}>
          <span className={styles.price}>
            {event.ticket_types_data.length > 1
              ? `от ${event.ticket_types_data[0].price} ₽`
              : `${getMinPrice(event.ticket_types_data)} ₽`}
          </span>
          <div className={styles.repost}>
            <button className={styles.repostLeft}>
              <img src={repost} alt={"repost"} />
              <span>Делиться</span>
            </button>
            <button className={styles.repostRight}>
              <img src={chevron} alt={chevron} />
            </button>
          </div>
          <span className={styles.category}>
            {event.categories_info[0].name}
          </span>
        </div>
      </section>
      <section className={styles.checkForm}>
        <div className={styles.topWrapper}>
          <h1 className={styles.title}>Проверить билет</h1>
        </div>
        <CheckForm
          id={event.id}
          eventData={eventData}
          foundTickets={foundTickets}
          setFoundTickets={setFoundTickets}
          type_form={"check"}
        />
      </section>
    </div>
  );
};
